import { CoreLadderHeader } from '../../../../views';
import h2h_teamplate from './templates/h2h.jst';
import open_teamplate from './templates/open.jst';
import overall_teamplate from './templates/overall.jst';
import './index.styl';

/**
 * @desc CoreLeagueLadderView Header Class
 * This class using on league loin page ('fantasy/league/ladder')
 */
export class LadderHeader extends CoreLadderHeader {
	getTemplate() {
		let template_type = this.model.get( 'template_type' ),
			status = this.model.get( 'status' );

		if( status !== 'scheduled' ) {
			switch ( template_type ) {
				case 'open':
					return open_teamplate;
				case 'h2h':
					return h2h_teamplate;
				case 'overall':
					return overall_teamplate;
				default:
					return open_teamplate;
			}
		}
		else {
			return false;
		}
	}
}

export default LadderHeader;